import { HttpService } from 'src/services';
import { GetManyResponse } from 'src/types';
import { Equipment, EquipmentDto } from 'src/models/Equipment';

const EquipmentService = {

  getAll: (): Promise<Equipment[]> => HttpService
    .get<GetManyResponse<EquipmentDto>>('/public/equipment')
    .then(response => response.data)
    .then(coaches => coaches.map(Equipment.fromDto)),

};

export default EquipmentService;
